import { useRouter } from 'next/router';
import Image from 'next/image';
import { getPlatformLinkUsingRouter, getSignupRedirectLink, useUserSettings } from '@bpm-web-app/utils';
import { useGetMeSubscriptionUnCached } from '@bpm-web-app/swr-hooks';
import { useMemo } from 'react';
import { SquaredButton } from '../squared-button/squared-button';
import styles from './anonymous-user-banner.module.css';
import bannerImage from '../../../assets/images/isAnonymousBanner-desktop.png';
import bannerImageMobile from '../../../assets/images/isAnonymousBanner-mobile.png';

import { BreakpointView } from '../ui';

interface AnonymousUserBannerProps {
    isCreate?: boolean;
}

export function AnonymousUserBanner({ isCreate }: AnonymousUserBannerProps) {
    const router = useRouter();
    const { data: subscriptionData, isLoading } = useGetMeSubscriptionUnCached(isCreate ? 'create' : 'supreme');
    const hasMembership = useMemo(() => subscriptionData?.data.membership.has_membership, [subscriptionData?.data.membership.has_membership]);
    const { isAnonymous } = useUserSettings();

    const handleOnPress = () => {
        if (!isAnonymous) router.push(getPlatformLinkUsingRouter('/account/plan'));
        else router.replace(getSignupRedirectLink());
    };

    if (isLoading) return null;
    if (!isAnonymous && hasMembership === undefined) return null;
    if (!isAnonymous && hasMembership) return null;

    return (
        <div className={styles['anonymous-user-banner']}>
            <div className={styles['anonymous-user-banner__text-container']}>
                {isCreate ? (
                    <span>
                        Get access to nearly one million royalty-free sounds
                    </span>
                ) : (
                    <span>
                        Start downloading unlimited DJ-ready music
                    </span>
                )}
                <SquaredButton type="filled" label="Get Started" fullWidth={false} onPress={handleOnPress} />
            </div>
            <BreakpointView
                desktopChildren={<Image quality={100} src={bannerImage} height={246} width={540} objectFit="cover" />}
                mobileChildren={<Image quality={100} src={bannerImageMobile} objectFit="cover" />}
            />
        </div>
    );
}
